export default __webpack_public_path__ + "static/media/Mior Cervical Spine Questionnaire.c63dba68.pdf";